// @ts-nocheck
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar"
import { Badge } from "@/components/ui/badge"
import { Button } from "./ui/button";

import {
    HoverCard,
    HoverCardContent,
    HoverCardTrigger,
  } from "@/components/ui/hover-card"

import { MouseEvent, useEffect, useState } from "react";
import ProfileMain from "./ProfileMain";
import ProfileList from "./ProfileList";
import { Navigate, useParams } from "react-router-dom";
import axios from "axios";
document.title = 'Profile';

// https://claude.site/artifacts/536517f3-4c16-4b01-b233-228f1e7bd839
// https://claude.site/artifacts/988a6d96-d734-4745-86b0-21819255000f
function Profile() {
    const [activePage,setActivePage] = useState("main");

    // check if logged in user is owner of profile (so they can see edit tools)
    const [isOwner, setIsOwner] = useState(false);
    const [bio, setBio] = useState("");

    const {username} = useParams();
    const accessToken = localStorage.getItem("accessToken");

    useEffect(() => {
        try{
            axios.get(`http://127.0.0.1:8000/api/auth/me/`, {
                headers: {
                Authorization: `Bearer ${accessToken}`,
                }
            })
            .then (res => {
                username == res.data.username ? setIsOwner(true) : setIsOwner(false);
            })
        }
        catch (error) {
            <Navigate to="/" />
        }

        // profile information fetch
        try{
            axios.get(`http://127.0.0.1:8000/api/auth/profile/${username}/`, {
                headers: {
                Authorization: `Bearer ${accessToken}`,
                }
            })
            .then (res => {
                console.log(res.data);
            })
        }
        catch (error) {
            <Navigate to="/" />
        }
      }, []);

    const handleNavClick = (event:MouseEvent<HTMLButtonElement>) => {
        switch (event.currentTarget.id) {
            case "mainNav":
                setActivePage("main")
                break;

            case "listNav":
                setActivePage("list")
                break;

            case "likeNav":
                setActivePage("like")
                break;

            case "laterNav":
                setActivePage("later")
                break;

            case "achieveNav":
                setActivePage("achieve")
                break;
            
            default:
                return;
        }
    }

    return(
        <main className="bg-foreground min-h-lvh h-full">
            <header className=" flex flex-col w-full justify-center items-center cursor-default overflow-x-hidden">
                <section className="relative flex flex-col justify-center items-center px-10 mt-15  ">
                   
                    <article className="flex flex-col gap-4 items-center bg-primary z-20 w-fit md:w-110 h-fit py-7 px-15 rounded-2xl">
                        <Avatar className="h-35 w-35 border-white border-4">
                            <AvatarImage src="https://cdn.shopify.com/s/files/1/1759/0923/files/4588813eefe6b6536bfa7e1d550434d0_480x480.jpg?v=1693652981" />
                            <AvatarFallback>:)</AvatarFallback>
                        </Avatar>
                        <div className="flex flex-col justify-center items-center gap-4">
                            <div className="flex flex-col justify-center items-center gap-4">
                                <h2 className="text-background text-4xl font-bold">{username}</h2>
                                <p className="text-neutral-400 text-sm text-center">{bio}</p>
                            </div>
                            <div className="flex gap-2 flex-wrap justify-center cursor-default">
                                <HoverCard>
                                    <HoverCardTrigger>
                                        <Badge variant="default" className="font-semibold text-secondary bg-blue-600">Early Adopter</Badge>
                                    </HoverCardTrigger>
                                    <HoverCardContent className="bg-foreground text-background">
                                        Join within the first week of launch.
                                    </HoverCardContent>
                                </HoverCard>

                                <HoverCard>
                                    <HoverCardTrigger>
                                        <Badge variant="default" className="font-semibold text-secondary bg-green-700">Sheep</Badge>
                                    </HoverCardTrigger>
                                    <HoverCardContent className="bg-foreground text-background">
                                        Have majority of liked movies be above a 7 rating
                                    </HoverCardContent>
                                </HoverCard>

                                <HoverCard>
                                    <HoverCardTrigger>
                                        <Badge variant="default" className="font-semibold text-secondary bg-red-800">Who put that there?!</Badge>
                                    </HoverCardTrigger>
                                    <HoverCardContent className="bg-foreground text-background">
                                        Delete over 100 items from lists.
                                    </HoverCardContent>
                                </HoverCard>
                            </div>
                            <div className="flex justify-around w-full">
                                <article className="flex flex-col  justify-center items-center hover:cursor-pointer">
                                    <h3 className="text-background font-black text-xl">33</h3>
                                    <p className="text-neutral-400 text-sm md:text-base">Lists</p>
                                </article>
                                <article className="flex flex-col justify-center items-center hover:cursor-pointer">
                                    <h3 className="text-background font-black text-xl">107</h3>
                                    <p className="text-neutral-400 text-sm md:text-base">Likes</p>
                                </article>  
                                <article className=" flex flex-col justify-center items-center hover:cursor-pointer">
                                    <h3 className="text-background font-black text-xl">8</h3>
                                    <p className="text-neutral-400 text-sm md:text-base">Friends</p>
                                </article>
                                <article className=" flex flex-col justify-center items-center hover:cursor-pointer">
                                    <h3 className="text-background font-black text-xl">45</h3>
                                    <p className="text-neutral-400 text-sm md:text-base">Points</p>
                                </article>
                            </div>
                        </div>
                    </article>
                    
                </section>
            </header>
            
            <section className="mt-15 z-2 flex flex-col items-center justify-center">
                <div className="flex justify-center items-center gap-6">

                    { // changes style of button that matches page state
                        activePage == "main" ? 
                        <Button id="mainNav" onClick={handleNavClick} className="text-background bg-neutral-800 rounded-2xl border-2 border-accent hover:cursor-pointer" variant="default">Main</Button> :
                        <Button id="mainNav" onClick={handleNavClick} className="text-background bg-neutral-800 rounded-2xl hover:cursor-pointer" variant="default">Main</Button>
                    }
                 
                    {
                        activePage == "list" ? 
                        <Button id="listNav" onClick={handleNavClick} className="text-background bg-neutral-800 rounded-2xl border-2 border-accent hover:cursor-pointer" variant="default">Lists</Button> :
                        <Button id="listNav" onClick={handleNavClick} className="text-background bg-neutral-800 rounded-2xl hover:cursor-pointer" variant="default">Lists</Button>
                    }

                    {
                        activePage == "like" ? 
                        <Button id="likeNav" onClick={handleNavClick} className="text-background bg-neutral-800 rounded-2xl border-2 border-accent hover:cursor-pointer" variant="default">Likes</Button> :
                        <Button id="likeNav" onClick={handleNavClick} className="text-background bg-neutral-800 rounded-2xl hover:cursor-pointer" variant="default">Likes</Button>
                    }

                    {
                        activePage == "later" ? 
                        <Button id="laterNav" onClick={handleNavClick} className="text-background bg-neutral-800 rounded-2xl border-2 border-accent hover:cursor-pointer" variant="default">Consume later</Button> :
                        <Button id="laterNav" onClick={handleNavClick} className="text-background bg-neutral-800 rounded-2xl hover:cursor-pointer" variant="default">Consume later</Button> 
                    }

                    {
                        activePage == "achieve" ? 
                        <Button id="achieveNav" onClick={handleNavClick} className="text-background bg-neutral-800 rounded-2xl border-2 border-accent hover:cursor-pointer" variant="default">Achievements</Button> :
                        <Button id="achieveNav" onClick={handleNavClick} className="text-background bg-neutral-800 rounded-2xl hover:cursor-pointer" variant="default">Achievements</Button>
                    }
                
                    
                    
                </div>

                
            </section>

            <section className="pb-5">
                { // renders body of profile depending on page state
                    activePage == "main" ? <ProfileMain /> : null
                }

                {
                    activePage == "list" ? <ProfileList /> : null
                }

                {
                    activePage == "like" ? <p></p> : null
                }

                {
                    activePage == "later" ? <p></p> : null
                }

                {
                    activePage == "achieve" ? <p></p> : null
                }
            </section>
            
          
        </main>
        

    )
}


export default Profile;





/*
 <div className="relative invisible lg:visible z-10 ">
                        <div className="absolute left-80 top-60 h-50 w-40 -rotate-10 ease-in-out duration-200 bg-green-400 opacity-40 hover:opacity-100 hover:scale-105 hover:cursor-pointer">
                            <img src="https://image.tmdb.org/t/p/w500//vR7hwaGQ0ySRoq1WobiNRaPs4WO.jpg" />

                        </div>
                    </div>
                    <div className="relative z-10 invisible lg:visible">
                        <div className="absolute right-100 top-10 rotate-15 h-50 w-40 ease-in-out duration-200 bg-blue-400 opacity-40 hover:opacity-100 hover:scale-105 hover:cursor-pointer">
                            <img src="https://image.tmdb.org/t/p/w500//g5IoYeudx9XBEfwNL0fHvSckLBz.jpg" />

                        </div>
                    </div>
                    <div className="relative z-10 invisible lg:visible">
                        <div className="absolute right-80 top-70 h-40 w-40 ease-in-out duration-200 opacity-40 hover:opacity-100 hover:scale-105 hover:cursor-pointer bg-pink-400">
                            <img src="https://i.scdn.co/image/ab67616d0000b273a12c5353b3d0385c6ce8c103" />
                        </div>
                    </div>
                    <div className="relative z-10 invisible lg:visible">
                        <div className="absolute left-100 h-40 w-40 ease-in-out duration-200 opacity-40 hover:opacity-100 hover:scale-105 hover:cursor-pointer bg-yellow-400">
                            <img src="https://i.scdn.co/image/ab67616d0000b273712701c5e263efc8726b1464" />

                        </div>
                    </div>

*/